import Persistable from "../../storage/persistable";

export default class Sync extends Persistable {
    constructor(eventId) {
        super();
        this.eventId = eventId;
        this.queuedSync = { timestamp: null, data: null };
        this.timeSynced = null;
        this.syncError = false;
    }
}
